import { Typography } from "@mui/material";
import { styled } from "@mui/system";

export const Container = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#FFFFFF",
});

export const SoundWaveBars = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const Bar = styled("div")<{ animationDuration: string; color: string }>(
  ({ animationDuration, color }) => ({
    width: "6px",
    margin: "0 1px",
    backgroundColor: color,
    borderRadius: "4px",
    animation: `waveAnim ${animationDuration} ease-in-out infinite alternate`,
    "@keyframes waveAnim": {
      "0%": {
        height: "20px",
        opacity: 0.33,
      },
      "100%": {
        height: "60px",
        opacity: 1,
      },
    },
  })
);

export const ColorFullText = styled(Typography)({
  backgroundImage: "linear-gradient(90deg, darkred, darkorange, darkgoldenrod, darkgreen, darkblue, indigo, darkviolet)",
  WebkitBackgroundClip: "text",
  color: "transparent",
  fontSize: "14px",
  fontWeight: "bold",
});
